var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',{class:_vm.b()},[_c('bonds-table-head',{attrs:{"labels":_vm.headLabels}}),_c('bonds-table-body',{attrs:{"entries":_vm.items,"parse-value":_vm.parseValue}}),_c('bonds-table-foot',{attrs:{"entries":_vm.totals,"parse-value":_vm.parseValue}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }